import { initializeApp } from "firebase/app";
import type { FirebaseOptions } from "firebase/app";

// Native builds get the config from google-services.json GoogleService-Info.plist
// This is Web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyDn-Nys1hgPw4TKznTQqlbsBF0fjRA2xWo",
  authDomain: "expo-app-se.firebaseapp.com",
  projectId: "expo-app-se",
  storageBucket: "expo-app-se.appspot.com",
  messagingSenderId: "405708626072",
  appId: "1:405708626072:web:ea4f069ab0c0ec4441d8ed",
  measurementId: "G-ZCKPCD4V1B",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
